<template>
  <ProductDescription :product="product" />
  <VariantList class="text-center mt-4" :product-id="product.id" :variants="product.variants" />
  <div class="text-center mt-8">
    <GenericButton @click="this.redirectToPreviousPage">
      {{ $t("Back") }}
    </GenericButton>
  </div>
</template>

<script>
import { GenericButton } from "@estaly/ui";
import VariantList from "@/views/store/products/details/variant/VariantList.vue";
import ProductDescription from "@/views/store/products/details/description/ProductDescription.vue";
import { mapActions } from "vuex";
import { toCamelCase } from "@/utils/utils";

export default {
  components: {
    VariantList,
    ProductDescription,
    GenericButton,
  },
  data: () => {
    return {
      product: {},
    };
  },
  methods: {
    ...mapActions("store", ["withLoader"]),
    ...mapActions("products", ["fetch"]),

    async getProduct() {
      await this.withLoader(async () => {
        const response = await this.fetch({
          id: this.$route.params.id,
          includes: ["variants.matched_contracts", "variants"],
        });
        if (response?.success) this.product = toCamelCase(response.data);
      });
    },
    redirectToPreviousPage: function () {
      this.$router.push("/platform/products");
    },
  },
  created() {
    this.getProduct();
  },
};
</script>
